export default __webpack_public_path__ + "533095a5247802a270f628f30e932fc3.png";